<template>
  <div class="compound banner public-content">
    <div class="breadcrumb">活动列表</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 15px">推广定位:</span>
        <el-select v-model="formInline.type" clearable placeholder="请选择">
          <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="margin-left:20px;">
        <el-button round @click="queryInfo.pageNum = 1, getBannerPage()">查询</el-button>
        <el-button round @click="detail(null)" type="primary">新建</el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <div class="main-content">
          <div class="banner-table">
            <el-table border class="table-cell" :data="tableList">
              <el-table-column prop="id" label="ID"></el-table-column>
              <el-table-column label="产品名称">
                <template v-slot="scope">
                  <!-- {{ prodName(scope.row) }} --> {{ scope.row.name }} </template>
              </el-table-column>
              <el-table-column prop="typeName" label="推广定位">
              </el-table-column>
              <el-table-column prop="sort" label="排序"></el-table-column>
              <el-table-column label="操作" fixed="right">
                <template v-slot="scope">
                  <span class="color-blue" @click="detail(scope.row.id)">编辑<br></span>
                  <span class="color-blue" @click="deleteBanner(scope.row.id)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <pagination @changePage="changePage" :queryInfo="queryInfo"></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from '@/components/Pagination/index.vue'
import { getBannerPage, delBanner } from '@/api/banner'
import { spuList } from '@/api/pms'

export default {
  name: 'banner',
  components: {
    pagination
  },
  data () {
    return {
      tableList: [],
      formInline: {
        type: null
      },
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      types: [{
        label: '新品发布',
        value: '0'
      }, {
        label: '项目展示',
        value: '1'
      }
        //  {
        //   label: 'C端活动推广',
        //   value: '2'
        // }
      ],
      form: {},
      where: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      tableData: [],
      tableDataStatus: {
        spuName: '', // 产品名称
        categoryId: '', // 产品类别
        isSeries: '', // 产品属性
        spuProperty: ''// 产品性质
      }
    }
  },
  computed: {
    // prodName () {
    //   return (val) => {
    //     let str = ''
    //     let obj = this.tableData.find(v => v.id === val.relationId)
    //     str = obj?.spuName
    //     return str
    //   }
    // }
  },
  async created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    // await this.getProList(this.where)
    await this.getBannerPage()
    if (this.$checkAwsSdk('normal')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'normal')
    }
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    async getProList (val) {
      await spuList({ pageNum: val.pageNum, pageSize: val.pageSize, spuVO: this.tableDataStatus }).then((res) => {
        if (res.data.success) {
          let list = res.data.data.records
          this.tableData = list
          console.log(this.tableData)
        }
      })
    },
    async getBannerPage () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      }
      let param = JSON.parse(JSON.stringify(this.formInline))
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      await getBannerPage({
        vo: param,
        params: {
          page: this.queryInfo.pageNum,
          size: this.queryInfo.pageSize,
          sort: 'dateCreated,desc'
        }
      }).then(res => {
        if (res.data.success) {
          this.tableList = res.data.data.records.map(item => {
            item.typeName = this.types.find(a => a.value === item.type).label
            return item
          })
          console.log(this.tableList)
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getBannerPage()
    },
    detail (bannerId) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({
        path: '/banner/detail',
        query: {
          id: bannerId,
          type: 'edit'
        }
      })
    },
    deleteBanner (bannerId) {
      this.$confirm('是否确定删除该Banner?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delBanner(bannerId).then(res => {
          if (res.data.success) {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
            this.queryInfo.pageNum = 1
            this.getBannerPage()
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
.compound {
  .add-category {
    justify-content: flex-start;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}
</style>
